import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/landing/Hero";
import { Marquee, Welcome, Technologies } from "../components/landing/Sections";
import { AboutIntro, HowWeWork, History, TeamBehindUs } from "../components/landing/Story";
import { Solutions, Industries, Testimonials, Awards, Clients } from "../components/landing/Showcase";
import Vacancies from "../components/landing/Vacancies";
import Hires from "../components/landing/Hires";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, [hash]);

  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <AboutIntro />
      <Welcome />
      <HowWeWork />
      <History />
      <Solutions />
      <Technologies />
      <Industries />
      <div id="jobs"><Vacancies /></div>
      <Hires />
      <TeamBehindUs />
      <Testimonials />
      <Awards />
      <Clients />
      <Footer />
    </div>
  );
}
